export default __webpack_public_path__ + "static/media/DSC_91130-thumb.305e5280.jpg";